/**
 * ╔════════════════════════════════════════════════════════════════════╗
 * ║  EVENT PAGE CONTENT — edit any value below to update the site      ║
 * ║  No design changes happen when you edit this file.                 ║
 * ║  Use "TBD" for anything you'll fill in later.                      ║
 * ╚════════════════════════════════════════════════════════════════════╝
 */

export const eventContent = {
  /* ─── Couple, date, venue ─────────────────────────────────────────── */
  couple: {
    bride: 'Mary Anthonette Ballah',
    groom: 'Gbelly Arrington Johnson'
  },
  shortNames: { bride: 'Mary', groom: 'Arrington' },
  hashtag: '#GodBlessTheJohnsons',
  motto: 'Grace Made Us. Purpose Unites Us.',
  date: {
    full: 'Saturday, July 31, 2027',
    short: '07 · 31 · 2027'
  },
  venue: {
    name: 'White & Sable',
    address: '15485 Baltimore St, Ham Lake, MN 55304',
    mapUrl: 'https://maps.google.com/?q=White+%26+Sable%2C+15485+Baltimore+St%2C+Ham+Lake%2C+MN+55304'
  },
  welcomeMessage:
    'Welcome to our wedding day. We are so honoured you are here to walk this chapter with us. May the moments ahead be filled with grace, laughter, and love.',

  /* ─── Wedding Day Timeline ────────────────────────────────────────── */
  timeline: [
    { time: '2:30 PM', title: 'Guest Arrival',  description: 'Doors open — please be seated by 2:50 PM.' },
    { time: '3:00 PM', title: 'Ceremony',       description: 'The exchange of vows.' },
    { time: '4:30 PM', title: 'Cocktail Hour',  description: 'Drinks, hors d\u2019oeuvres, and music.' },
    { time: '6:00 PM', title: 'Reception',      description: 'Dinner, toasts, first dance.' },
    { time: '10:30 PM', title: 'Grand Exit',    description: 'A sparkler send-off into the evening.' }
  ],

  /* ─── Wedding Party ───────────────────────────────────────────────── */
  party: {
    officiant: { name: 'TBD', role: 'Officiant' },
    bestMan: { name: 'TBD' },
    matronOfHonor: { name: 'TBD' },
    bridesmaids: ['TBD', 'TBD', 'TBD'],
    groomsmen: ['TBD', 'TBD', 'TBD'],
    flowerGirls: ['TBD'],
    ringBearers: ['TBD'],
    parentsOfBride: ['TBD — Mother of the Bride', 'TBD — Father of the Bride'],
    parentsOfGroom: ['TBD — Mother of the Groom', 'TBD — Father of the Groom']
  },

  /* ─── Wedding Attire ──────────────────────────────────────────────── */
  attire: {
    brideGown:        { label: 'Bride\u2019s Gown',        designer: 'TBD', boutique: 'TBD', madeIn: 'TBD' },
    groomTuxedo:      { label: 'Groom\u2019s Tuxedo',      designer: 'TBD', tailor:   'TBD', madeIn: 'TBD' },
    bridesmaidDress:  { label: 'Bridesmaids\u2019 Dresses', designer: 'TBD', boutique: 'TBD', madeIn: 'TBD' },
    groomsmenTuxedo:  { label: 'Groomsmen\u2019s Tuxedos', designer: 'TBD', tailor:   'TBD', madeIn: 'TBD' }
  },

  /* ─── Wedding Vendors ─────────────────────────────────────────────── */
  vendors: [
    { role: 'Planner',         name: 'TBD' },
    { role: 'Decorator',       name: 'TBD' },
    { role: 'Master of Ceremonies', name: 'TBD' },
    { role: 'DJ',              name: 'TBD' },
    { role: 'Photographer',    name: 'TBD' },
    { role: 'Videographer',    name: 'TBD' },
    { role: 'Florist',         name: 'TBD' },
    { role: 'Cake',            name: 'TBD' },
    { role: 'Transportation',  name: 'TBD' }
  ],

  /* ─── Guest Information ───────────────────────────────────────────── */
  guestInfo: {
    dressCode: {
      title: 'Black Tie',
      description: 'Floor-length gowns for ladies, tuxedos or formal black suits for gentlemen.'
    },
    parking: 'Complimentary valet and self-parking available on site.',
    contact: { name: 'Day-of Coordinator', phone: 'TBD', email: 'TBD@gracemadeus.com' }
  },

  /* ─── FAQ ─────────────────────────────────────────────────────────── */
  faqs: [
    { q: 'What time should I arrive?', a: 'Please arrive by 2:30 PM so you are seated comfortably before the ceremony begins at 3:00 PM sharp.' },
    { q: 'Will the ceremony be indoors or outdoors?', a: 'The ceremony will be held at our venue. Specific indoor/outdoor details will be shared on the day.' },
    { q: 'Is there a dress code?', a: 'Yes — Black Tie. Please see the Guest Information section for details.' },
    { q: 'Are children invited?', a: 'Please refer to your invitation for specific guidance on children.' },
    { q: 'Can I take photos during the ceremony?', a: 'We kindly request an unplugged ceremony — please put phones and cameras away so our photographer can capture every moment. Photos are welcome at the reception.' },
    { q: 'Where do I park?', a: 'Complimentary valet and self-parking are available on site.' }
  ],

  /* ─── Optional: Photo Gallery & Love Story toggles ────────────────── */
  showGallery: true,
  showLoveStory: true
};
